import React from "react";
import ProjetoLayout from "../componentes/ProjetoLayout";

function NeonFinancas() {
  return (
    <ProjetoLayout
      titulo="Neon Finanças"
      tagline="Ecossistema inteligente de gestão financeira e controle de investimentos, com clareza e controle total sobre o patrimônio."
      liveUrl="https://neonfinancas.vercel.app/"
      capa="/capa-neon.png"
      capaAlt="Neon Finanças"
      tags={[
        "Next.js",
        "Supabase",
        "PostgreSQL",
        "TypeScript",
        "Prisma",
        "Tailwind CSS",
        "Auth",
        "Vercel",
      ]}
      meta={[
        { ic: "code", label: "Tipo", value: "Full-stack" },
        { ic: "role", label: "Papel", value: "Desenvolvedor" },
        { ic: "local", label: "Status", value: "No ar" },
      ]}
    >
      <h2>Gestão de ativos e controle de gastos</h2>
      <p>
        O <strong>Neon Finanças</strong> representa um salto na minha trajetória
        como desenvolvedor full-stack. É uma plataforma robusta para transformar a
        maneira como os usuários interagem com seu dinheiro, unindo o{" "}
        <strong>controle de movimentações diárias</strong> ao{" "}
        <strong>acompanhamento estratégico de investimentos</strong>.
      </p>
      <p>
        Focado em performance e segurança, o sistema usa uma arquitetura moderna
        que garante uma experiência personalizada e protegida. A interface foi
        pensada para ser limpa e direta, eliminando a complexidade comum das
        planilhas financeiras tradicionais.
      </p>

      <h3>Principais funcionalidades</h3>
      <ul>
        <li>
          <strong>Segurança com RLS:</strong> Row-Level Security no banco garante
          que os dados sejam acessados estritamente pelo dono da conta.
        </li>
        <li>
          <strong>Dashboard de investimentos:</strong> monitoramento de ativos com
          visualização gráfica e intuitiva da carteira.
        </li>
        <li>
          <strong>Gestão de fluxo de caixa:</strong> registro de receitas e
          despesas com categorização, orçamentos por categoria e sincronização em
          tempo real via Supabase.
        </li>
        <li>
          <strong>Metas financeiras:</strong> planejamento de grandes compras ou
          reserva de emergência, com progresso baseado nas economias reais.
        </li>
      </ul>
    </ProjetoLayout>
  );
}

export default NeonFinancas;
